import { Card, Col, Row } from 'antd';
import { useMemo } from 'react';
import { type TFunction, useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type SimpleVehicleManagementModuleSpecsFragment } from '../../../../api/fragments/SimpleVehicleManagementModuleSpecs';
import { TemplateType } from '../../../../api/types';
import SelectField from '../../../../components/fields/SelectField';
import useModuleOptions from '../modules/implementations/shared/useModuleOptions';

type SimpleVehicleManagementFormProps = {
    module: SimpleVehicleManagementModuleSpecsFragment;
};

const computeTemplateList = (name: string, t: TFunction) => {
    if (name === 'BMW') {
        return [
            {
                value: TemplateType.AfcTemplate,
                label: t('moduleDetails:explanations.templates.AFCTemplate.label'),
            },
            {
                value: TemplateType.BmwTemplate,
                label: t('moduleDetails:explanations.templates.BMWTemplate.label'),
            },
        ];
    }

    return [
        {
            value: TemplateType.AfcTemplate,
            label: t('moduleDetails:explanations.templates.AFCTemplate.label'),
        },
    ];
};

const SimpleVehicleManagementForm = ({ module }: SimpleVehicleManagementFormProps) => {
    const { t } = useTranslation(['simpleVehicleManagementDetail', 'moduleDetails']);

    const defaultTemplate = useMemo(
        () => computeTemplateList(module.company.displayName, t),
        [module.company.displayName, t]
    );

    const options = useModuleOptions(module.company, { addNoneOptions: { porscheMasterData: true } });

    return (
        <Card title={t('simpleVehicleManagementDetail:subTitle')}>
            <Row gutter={10}>
                <Col md={8} xs={24}>
                    <SelectField
                        {...t('simpleVehicleManagementDetail:fields.importExportTemplate', { returnObjects: true })}
                        name="defaultTemplate"
                        options={defaultTemplate}
                        required
                        showSearch
                    />
                </Col>
                {options.porscheMasterData.length > 1 && (
                    <Col md={8} xs={24}>
                        <SelectField
                            {...t('simpleVehicleManagementDetail:fields.porscheMasterDataModule', {
                                returnObjects: true,
                            })}
                            name="porscheMasterDataModuleId"
                            options={options.porscheMasterData}
                            showSearch
                        />
                    </Col>
                )}
            </Row>
        </Card>
    );
};

export default SimpleVehicleManagementForm;
